import { lazyPage, type ModulePlugin } from "@keel/core";
import { LowStockTile } from "./Tile";

const inventory = () => import("./Inventory");
const productStock = () => import("./ProductStock");
const Stock = lazyPage(inventory, "Stock");
const Movements = lazyPage(inventory, "Movements");
const WarehousesTab = lazyPage(() => import("./Warehouses"), "WarehousesTab");
const ProductStockStats = lazyPage(productStock, "ProductStockStats");
const ProductOnHandCell = lazyPage(productStock, "ProductOnHandCell");
const ProductStockSections = lazyPage(productStock, "ProductStockSections");

/**
 * Inventory: stock levels, movements, warehouses (Settings tab) and the stock parts of the product
 * card. Ported from the prototype's `pages/inventory/Inventory.tsx`.
 */
const plugin: ModulePlugin = {
  key: "inventory",
  help: () => import("./help"),
  nav: [
    {
      group: "Inventory",
      items: [
        { to: "/inventory", label: "Stock", icon: "warehouse", perm: "inventory.stock.read" },
        { to: "/stock-movements", label: "Movements", icon: "moves", perm: "inventory.stock.read" },
      ],
    },
  ],
  routes: [
    { path: "/inventory", element: <Stock /> },
    { path: "/stock-movements", element: <Movements /> },
  ],
  commands: [
    ["Stock levels", "/inventory", "warehouse", "inventory.stock.read"],
    ["Low stock", "/inventory?low=1", "alert", "inventory.stock.read"],
    ["Stock movements", "/stock-movements", "moves", "inventory.stock.read"],
    ["Warehouses", "/settings?tab=warehouses", "warehouse", "inventory.stock.read"],
  ],
  settingsTabs: [
    { key: "warehouses", label: "Warehouses", perm: "inventory.stock.read", element: <WarehousesTab /> },
  ],
  productStats: [{ key: "stock", perm: "inventory.stock.read", component: ProductStockStats }],
  productColumns: [
    {
      key: "onHand",
      label: "On hand",
      perm: "inventory.stock.read",
      align: "right",
      component: ProductOnHandCell,
    },
  ],
  productSections: [{ key: "stock", perm: "inventory.stock.read", component: ProductStockSections }],
  dashboardTiles: [
    { key: "inventory", section: "inventory", perm: "inventory.stock.read", component: LowStockTile },
  ],
};
export default plugin;
